var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSplashTop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 129,
    viewBox: "0 0 390 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 99.1751L390 63.1618L0 63.1618L0 99.1751Z",
    fill: "#47C8BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M390 0L0 0L0 63.1618L390 63.1618V0Z",
    fill: "#80D7D1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 122.445C86.9022 135.742 134.263 124.298 201 111.918C266.707 99.729 361.209 101.206 390 111.918V63.1618L0 99.1751L0 122.445Z",
    fill: "#CAEDEB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplashTop);
export default __webpack_public_path__ + "static/media/splashTop.8e69640fcb14b7b64f8f654e84d295e9.svg";
export { ForwardRef as ReactComponent };